import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";

export class Quiz {

  constructor(level, el) {
    this.parentLevel = level;
    this.$screen = this.parentLevel.$screen;
    this.$el = $(el);
    this.locked = false;

    this.$selectedAnswer = null;

    this.answeredQuestions = [];
    this.maxAnsweredCount = this.$el.find(".question").length;

    this.answerScreenTimeout = null
    this.answerScreenHandZoomDelay = 2000; // ms before continuing after last step

    this.init();
  }

  init() {
    this.$el.find(".choice").on("click", (e) => this.choiceClicked(e));

    // Retrigger animations on language change
    $(document).on('i18nFlip i18nSet', (e) => this.playAnimation());

    this.shuffleChoices();
  }

  choiceClicked(e) {
    if (this.locked) return;
    this.lockQuiz();

    const event = e;
    const el = $(e.currentTarget);

    // Add active class. If finger is held (not a click) :active is not handled correctly.
    // This help to have visual feedback in both case.
    el.addClass("_active_");

    const functionDelay = (typeof el.data("action-delay") != "undefined" ? el.data("action-delay") : 50);

    requestTimeout(() => {
      el.removeClass("_active_");
      this.selectAnswer(event);
    }, functionDelay);
  }

  selectAnswer(e) {
    const $choice = $(e.currentTarget);

    app.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_INT_SFXselection.mp3", 1, true)
    const questionId = $choice.parents(".question").data("question-id");
    const selectedAnswerId = $choice.data("choice-id");
    const choiceCorrect = $choice.data("correct");

    this.$selectedAnswer = $(`.answers-container .answer[data-question-id='${questionId}']`);

    if (!this.answeredQuestions.includes(questionId)) {
      this.answeredQuestions.push(questionId);
    }

    // Reset some things
    $choice.parents(".question").find(".choice").removeClass("user-selected");
    $choice.parents(".question").find(`.choice[data-choice-id='${selectedAnswerId}']`).addClass("user-selected");
    $(`.answers-container .choice`).removeClass("user-selected");
    $(`.answers-container .answer[data-question-id='${questionId}'] .choice[data-choice-id='${selectedAnswerId}']`).addClass("user-selected");

    this.showFeedback($choice);
  }

  showFeedback($choice) {
    const choiceCorrect = $choice.data("correct");
    const shouldShowCamera = this.$selectedAnswer.data("show-camera");

    if (this.$selectedAnswer.find(".answer-lottie").length) {
      const $animations = this.$selectedAnswer.find(".answer-lottie .lottie-animation")
      $animations.each((i, n) => {
        const lottie = $(n).data('lottie');
        lottie.setFrame(0)
        lottie.stop();
      })
    }

    this.transitionTimeline = gsap.timeline({
      onComplete: () => {
        // Show the correct answer on the previous page
        $choice.parents(".question").addClass("answered");

        if (this.answerScreenTimeout !== null) {
          clearTimeout(this.answerScreenTimeout);
          this.answerScreenTimeout = null;
        }

        this.answerScreenTimeout = setTimeout(() => {
          this.parentLevel.showHandZoomAnimation("out");
        }, this.answerScreenHandZoomDelay)
      }
    });


    if (shouldShowCamera) {
      this.transitionTimeline.to(this.$screen.find(".step-2").find(".step-background, .quiz-question, .questions-container"),
        {
          autoAlpha: 0,
        });
    } else {
      this.transitionTimeline.to(this.$screen.find(".step-2").find(".quiz-question, .questions-container"),
        {
          autoAlpha: 0,
        });
    }

    // Play sound effect depending on good/wrong answer
    if (choiceCorrect) {
      this.transitionTimeline.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXreponsebonne.mp3", 1, true))
    } else {
      this.transitionTimeline.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXreponsemauvaise.mp3", 1, true))
    }

    this.transitionTimeline.fromTo(this.$selectedAnswer,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      });


    this.transitionTimeline.fromTo(this.$selectedAnswer.find(".answer-title"),
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      });

    this.transitionTimeline.fromTo(this.$selectedAnswer.find(".answer-text"),
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      });

    // if (this.$selectedAnswer.find(".answer-lottie").length) {
    //   this.transitionTimeline.fromTo(this.$selectedAnswer.find(".answer-lottie"),
    //     {
    //       autoAlpha: 0,
    //     },
    //     {
    //       autoAlpha: 1,
    //     });
    // }

    this.transitionTimeline.fromTo(this.$selectedAnswer.find(`.choice`),
      {
        scale: 0,
        autoAlpha: 0,
      },
      {
        scale: 1,
        autoAlpha: 1,
        ease: "back.out",
        stagger: 0.1
      });

    if (this.$selectedAnswer.find(".answer-lottie").length) {
      this.transitionTimeline.add(() => this.playAnimation(), "-=0.5");
    }
  }

  playAnimation() {
    if (this.$selectedAnswer?.find(".answer-lottie").length) {
        const lottie = this.$selectedAnswer.find(`.answer-lottie .${app.i18n.lang} .lottie-animation`).data('lottie');
        lottie.play();
    }
  }

  hideFeedback() {
    this.parentLevel.hideHandZoomAnimation();

    app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXzoomOut.mp3", 1, true);

    this.transitionTimeline = gsap.timeline({
      onComplete: () => {
        if (this.$selectedAnswer.find(".answer-lottie").length) {
          const $animations = this.$selectedAnswer.find(".answer-lottie .lottie-animation")
          $animations.each((i, n) => {
            const lottie = $(n).data('lottie');
            lottie.stop()
            lottie.setFrame(0)
          })
        }

        this.unlockQuiz();
      }
    });

    this.transitionTimeline.to(this.$selectedAnswer,
      {
        autoAlpha: 0,
      });

    // reset things
    this.transitionTimeline.to(this.$screen.find(".step-2").find(".step-background, .quiz-question, .questions-container"),
      {
        autoAlpha: 1,
      });
  }

  shuffleChoices() {
    // Here we need to shuffle the question choices BUT also the related answer choices so they are in the same order
    // We'll sort the questions first and apply the same sort to the related answer choices
    this.$el.find(".question").each((i, choicesContainer) => {
      let questionId = $(choicesContainer).data('question-id');
      let $choices = $(choicesContainer).find('.question-choices');
      let $answerChoices = this.$el.find('.answer[data-question-id="' + questionId + '"]').find('.answer-choices');

      // Get choice IDs from the question so we can order them and take that order and apply it
      let order = [];
      $choices.find('.choice').each(function (i, el) {
        order.push($(el).data('choice-id'));
      })

      // Now randomize it
      order.sort(function () {
        return Math.random() - 0.5;
      });

      // Proceed with reorder for the question and answer
      this.reoderChoices($choices, order);
      this.reoderChoices($answerChoices, order);
    })
  }


  reoderChoices($container, order) {
    // We'll get the choices in the order we have, and put them back in their container
    let orderedChoices = []
    $container.find(".choice").each(function (i, el) {
      orderedChoices[$(el).data('choice-id')] = el;
    })

    order.forEach((id) => {
      if (orderedChoices[id]) {
        $container.append(orderedChoices[id]);
      }
    });
  }

  lockQuiz() {
    this.locked = true;
    this.$el.addClass("locked");
  }

  unlockQuiz() {
    if (this.answeredQuestions.length >= this.maxAnsweredCount) {
      // Last, show Seve CTA and keep locked
      gsap.to(this.$screen.find(`.seve-cta-container`), {autoAlpha: 1, delay: 1});
    } else {
      this.locked = false;
      this.$el.removeClass("locked");
    }

  }

  killTimeline(tl) {
    if (tl) {
      tl.pause();
      tl.seek(0);
      tl.kill()
      tl = null;
    }
  }

  reset() {
    if (this.answerScreenTimeout !== null) {
      clearTimeout(this.answerScreenTimeout);
      this.answerScreenTimeout = null;
    }

    this.killTimeline(this.transitionTimeline);

    this.$el.find(".question").removeClass("answered");
    this.$el.find(".question").find(".choice").removeClass("user-selected");

    // Clear all the transforms on the steps so they'll go back to initial state
    gsap.set(this.$el, {clearProps: "all"});
    gsap.set(this.$screen.find(".step-2").find(".step-background, .quiz-question, .questions-container, .question, .choice"), {clearProps: "all"});

    if (this.$selectedAnswer) {
      gsap.set(this.$selectedAnswer, {clearProps: "all"});
    }

    this.$selectedAnswer = null;
    this.answeredQuestions = [];

    this.shuffleChoices();

    this.unlockQuiz();
  }

}
